import { createSHA256 } from "hash-wasm";

// Matches uploadAudioHelpers' DEFAULT_BLOCK_SIZE - not imported from there since that constant
// sizes network upload blocks, an unrelated concern to this local CPU hash.
const HASH_CHUNK_SIZE_BYTES = 16 * 1024 * 1024;

// Shared SHA-256 hashing primitive used both to hash a reconstructed recording (see
// getAudioHashFromRecordingId in indexedDBUtils.ts) and to hash individually uploaded files.
// Hashes in fixed-size chunks via hash-wasm's incremental hasher rather than loading the whole
// blob into one buffer - files here can be GB-scale, and Web Crypto's digest() has no incremental
// API to bound that memory usage. Same SHA-256 algorithm, byte-identical result either way.
export const hashBlob = async (blob: Blob): Promise<string> => {
  const hasher = await createSHA256();
  hasher.init();

  let offset = 0;
  while (offset < blob.size) {
    const chunk = blob.slice(offset, offset + HASH_CHUNK_SIZE_BYTES);
    hasher.update(new Uint8Array(await chunk.arrayBuffer()));
    offset += HASH_CHUNK_SIZE_BYTES;
  }

  return hasher.digest("hex");
};

// Combines per-file hashes into the single filesHash the commit-upload endpoint expects:
// a single file's hash is used as-is, multiple files are combined into a hash of hashes.
export const combineFileHashes = async (hashes: string[]): Promise<string> => {
  if (hashes.length === 1) {
    return hashes[0];
  }

  return hashBlob(new Blob([hashes.join("")]));
};
